<template>
    <tr :class="`${isEditRequested ? 'edit-row' : ''}`">
        <td>
            {{ dme.name }}
        </td>
        <td>
            {{ dme.isInfusionPump ? "Yes" : "No" }}
        </td>
        <td v-if="!isDeleteRequested">
            <span v-if="!isEditRequested">
                <span v-if="dme.startDate">
                    {{ formatDate(dme.startDate) }}
                </span>
                <span v-else> - </span>
            </span>
            <DatePicker :getDate="onDateChange" v-else>
                <div class="input-group date datepickerInput">
                    <input
                        type="text"
                        class="form-control"
                        :value="formatDateInput(dme.startDate)"
                        placeholder="MM/DD/YYYY"
                        date-format-only
                        @blur="v$.dme.startDate.$touch"
                        :class="`${!v$.dme.startDate.$error ? '' : 'field-invalid'}`"
                    />
                    <div class="input-group-addon input-group-append">
                        <div class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </DatePicker>
        </td>
        <td v-if="!isDeleteRequested">
            <span v-if="!isEditRequested">
                <span v-if="dme.endDate">
                    {{ formatDate(dme.endDate) }}
                </span>
                <span v-else> - </span>
            </span>
            <DatePicker :getDate="onDateChange" v-else>
                <div class="input-group date datepickerInput">
                    <input
                        type="text"
                        class="form-control"
                        :value="formatDateInput(dme.endDate)"
                        placeholder="MM/DD/YYYY"
                        date-format-only
                    />
                    <div class="input-group-addon input-group-append">
                        <div class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </DatePicker>
        </td>
        <!-- ACTIONS -->
        <td class="text-end" v-if="!isEditRequested && !isDeleteRequested">
            <button type="button" class="btn table-btn btn-outline-info" @click="editDme()">
                <i class="fas fa-edit"></i>
            </button>
            <button type="button" class="btn table-btn btn-outline-danger" v-if="!dme.id" @click="requestDeleteDme()">
                <i class="fas fa-trash-alt"></i>
            </button>
        </td>
        <!-- EDIT -->
        <td class="button-cell text-end" v-if="isEditRequested">
            <button type="button" class="btn table-btn btn-outline-success" @click="saveEdit()">Save</button>
            <button type="button" class="btn table-btn btn-outline-secondary" @click="cancelEdit()">Cancel</button>
        </td>
        <!-- DELETE -->
        <td colspan="3" v-show="isDeleteRequested">
            <TablePrompt
                :message="`Are you sure want to delete ${dme.name}?`"
                ok-text="delete"
                name="Delete"
                :ok="deleteDme"
                :cancel="cancelDelete"
            >
            </TablePrompt>
        </td>
    </tr>
</template>

<script lang="ts" src="./DMETableRow.ts"></script>
